import { render, staticRenderFns } from "./NewsLists.vue?vue&type=template&id=2167bd13&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewsLists.vue"
export default component.exports